import { render, staticRenderFns } from "./Meta.vue?vue&type=template&id=5bed72d2"
import script from "./Meta.vue?vue&type=script&lang=js"
export * from "./Meta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports